import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../i18n';
import { getFlagUrl } from '../i18n/languages';
import './LanguageSelector.css';

function LanguageSelector() {
  const { lang, setLang, meta, languages } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="lang-selector" ref={ref}>
      <button className="lang-toggle" onClick={() => setOpen(!open)}>
        <img className="lang-flag-img" src={getFlagUrl(meta.country)} alt={meta.label} loading="lazy" />
        <span className="lang-code">{lang.toUpperCase()}</span>
      </button>
      {open && (
        <div className="lang-dropdown">
          {languages.map((l) => (
            <button
              key={l.code}
              className={`lang-option ${l.code === lang ? 'active' : ''}`}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
            >
              <img className="lang-flag-img" src={getFlagUrl(l.country)} alt={l.label} loading="lazy" />
              <span className="lang-label">{l.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default LanguageSelector;
